import script from "./currAccordianItem.vue?vue&type=script&setup=true&lang=js"
export * from "./currAccordianItem.vue?vue&type=script&setup=true&lang=js"

import "./currAccordianItem.vue?vue&type=style&index=0&id=d5e31100&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5e31100"]])

export default __exports__